import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import { sortOptions } from "../config"

export default function Sort() {
    const { activeSort, setSort } = useSort(sortOptions)
    const [active, setActive] = useState(false) 

    useEffect(() => {
        const isDesktop = window.matchMedia("(min-width: 768px)").matches
        if (isDesktop && !active) {
            setActive(true)
        }
    }, []) 

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    return (
        <li className={`ns-sidebar-dropdown border-b border-solid color-border-dark ${active ? "ns-active" : ""}`} aria-expanded={!!active}>
            <span
                className="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box"
                data-nosto-element="sort"
                onClick={() => setActive(!active)}
                aria-controls="sort-sub-menu"
                aria-label={`${active ? "Collapse" : "Expand"} Sort options`}
            >
                <span className="color-text text-[18px]">Sort by</span>
                {active ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
                        <path d="M18 12.5H6" stroke="#191919" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
                        <path d="M12 6.21875V12.2188M12 12.2188V18.2188M12 12.2188H18M12 12.2188L6 12.2187" stroke="#191919" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                )}
            </span>
            <div className={`ns-sidebar-submenu ${active ? "" : "ns-d-none"}`} id="sort-sub-menu">
                <ul className="ns-list-unstyled ns-p-0 ns-m-0 grid gap-2" role="menu">
                    {sortOptions.map(option => (
                        <li
                            key={option.id}
                            className="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                            data-nosto-element="sort-setting"
                            role="menuitem"
                        >
                            <label className="ns-radio-option ns-d-flex ns-align-items-center">
                                <input
                                    type="radio"
                                    value={option.id}
                                    checked={activeSort === option.id}
                                    onChange={handleSortChange}
                                    className="ns-radio-input ns-mr-1"
                                />
                                <span>{option.value.name}</span>
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}